<h2 class="content-card__header">{{ 'UF-BasicData' | translate }}</h2>

<form [formGroup]="firstTabForm">
  <div class="row">
    <div class="col-12 col-lg-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FirstName' | translate }}</mat-label>
        <input matInput placeholder="{{ 'FirstName' | translate }}" autocomplete="given-name" formControlName="firstName" required />
        @if (firstName.invalid && firstName.touched) {
          <mat-error>
            {{ 'InvalidField' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'LastName' | translate }}</mat-label>
        <input matInput placeholder="{{ 'LastName' | translate }}" autocomplete="family-name" formControlName="lastName" required />
        @if (lastName.invalid && lastName.touched) {
          <mat-error>
            {{ 'InvalidField' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-lg-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'EmailAdress' | translate }}</mat-label>
        <input matInput placeholder="{{ 'EmailAdress' | translate }}" autocomplete="email" formControlName="email" required />
        @if (email.invalid && email.touched) {
          <mat-error>
            {{ 'InvalidField' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-6">
      <mat-form-field appearance="outline" fxFill>
        <mat-label>{{ 'PhoneNumber' | translate }}</mat-label>
        <input
          matInput
          placeholder="{{ 'PhoneNumber' | translate }}"
          autocomplete="phoneNumber"
          [maxLength]="12"
          formControlName="phone"
          appNumbersOnly
          required
          />
          @if (phone.invalid && phone.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-6">
        <mat-checkbox class="example-margin" formControlName="sendWelcomeMessage">{{ 'UF-SendWelcomeMessage' | translate }}</mat-checkbox>
      </div>
      @if (isEmployeeInformationVisible()) {
        <div class="col-12 col-lg-6">
          <mat-label>{{ 'UF-IsEmployee' | translate }}</mat-label>
          <mat-checkbox formControlName="isEmployee" class="example-margin"></mat-checkbox>
        </div>
      }
    </div>
  </form>

  <h2 class="content-card__header">{{ 'UserRole' | translate }}</h2>

  <form [formGroup]="firstTabForm">
    <div class="row">
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Role' | translate }}</mat-label>
          <mat-select formControlName="roleId" (selectionChange)="onRoleChange()">
            @for (r of roles; track r) {
              <mat-option [value]="r.Id"> {{ r.Name }}</mat-option>
            }
          </mat-select>
          @if (roleId.invalid && roleId.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  </form>

  <h2 class="content-card__header">{{ 'Employer' | translate }}</h2>

  <form [formGroup]="firstTabForm">
    <div class="row">
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Employer' | translate }}</mat-label>
          <input type="text" matInput [formControl]="organization" [matAutocomplete]="autoOrganization" />
          <mat-autocomplete autoActiveFirstOption #autoOrganization="matAutocomplete" [displayWith]="displayValue">
            @for (item of organizations$ | async; track item) {
              <mat-option [value]="item">
                {{ item.Name }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (organization.invalid && organization.touched) {
            <mat-error> {{ 'InvalidField' | translate }} </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Supervisor' | translate }}</mat-label>
          <input type="text" matInput [formControl]="supervisor" [matAutocomplete]="autoSupervisor" />
          <mat-autocomplete autoActiveFirstOption #autoSupervisor="matAutocomplete" [displayWith]="displayValue">
            @for (item of supervisors$ | async; track item) {
              <mat-option [value]="item">
                {{ item.Name }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (supervisor.invalid && supervisor.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    @if (!isSelfForm()) {
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-raised-button color="primary" (click)="onNextTab()">{{ 'Save' | translate }}</button>
      </div>
    }
  </form>
